<template>
  <div class="createCertifyzz" v-if="clubVersion === 'v2'">
    <modal-upload></modal-upload>
    <div class="container">
      <b-row class="spaceAddCertify">

        <b-col cols="12" md="3" class="pt-5" data-anima="top">
          <div class="navigate">
            <div class="title title-v2">{{ nameCourse }}
              <button id="viewModuleLesson" class="viewModuleLesson" @click="viewCourse()">
                  Ver Curso
                  <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.375 8.75L12.5 5.625L9.375 2.5" stroke="#C4C4C4" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M2.5 12.5V8.125C2.5 7.46194 2.76339 6.82606 3.23223 6.35725C3.70107 5.88839 4.33696 5.625 5 5.625H12.5" stroke="#C4C4C4" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              </button>
            </div>
            <div class="lineDiv"></div>
            <router-link :to="'/config_curso/' + cursoAtual" class="removeLink">
              <div class="spaceNav">
                <div class="text"><svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M17 0H3C2.20435 0 1.44129 0.316071 0.87868 0.87868C0.316071 1.44129 0 2.20435 0 3V11C0 11.7956 0.316071 12.5587 0.87868 13.1213C1.44129 13.6839 2.20435 14 3 14H9V16H5C4.73478 16 4.48043 16.1054 4.29289 16.2929C4.10536 16.4804 4 16.7348 4 17C4 17.2652 4.10536 17.5196 4.29289 17.7071C4.48043 17.8946 4.73478 18 5 18H15C15.2652 18 15.5196 17.8946 15.7071 17.7071C15.8946 17.5196 16 17.2652 16 17C16 16.7348 15.8946 16.4804 15.7071 16.2929C15.5196 16.1054 15.2652 16 15 16H11V14H17C17.7956 14 18.5587 13.6839 19.1213 13.1213C19.6839 12.5587 20 11.7956 20 11V3C20 2.20435 19.6839 1.44129 19.1213 0.87868C18.5587 0.316071 17.7956 0 17 0ZM18 11C18 11.2652 17.8946 11.5196 17.7071 11.7071C17.5196 11.8946 17.2652 12 17 12H3C2.73478 12 2.48043 11.8946 2.29289 11.7071C2.10536 11.5196 2 11.2652 2 11V3C2 2.73478 2.10536 2.48043 2.29289 2.29289C2.48043 2.10536 2.73478 2 3 2H17C17.2652 2 17.5196 2.10536 17.7071 2.29289C17.8946 2.48043 18 2.73478 18 3V11Z" fill="#333333"/>
</svg>
 Dados do Curso
</div>
                <img src="@/assets/icons/arrow-navigate.svg" />
              </div>
            </router-link>
            <div class="lineDiv"></div>
            <router-link
              :to="'/config_curso/' + cursoAtual + '/module'"
              class="removeLink"
              :class="{ disableLink: existParans }"
            >
              <div class="spaceNav">
                <div class="text"><svg width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M21.47 16.82L20.47 12.96L17.32 1.37003C17.2519 1.11437 17.0853 0.896104 16.8567 0.76303C16.628 0.629955 16.3559 0.592918 16.1 0.66003L12.23 1.66003C12.1376 1.55767 12.0251 1.47552 11.8995 1.41873C11.7739 1.36194 11.6379 1.33174 11.5 1.33003H1.5C1.23478 1.33003 0.98043 1.43539 0.792893 1.62292C0.605357 1.81046 0.5 2.06481 0.5 2.33003V18.33C0.5 18.5952 0.605357 18.8496 0.792893 19.0371C0.98043 19.2247 1.23478 19.33 1.5 19.33H11.5C11.7652 19.33 12.0196 19.2247 12.2071 19.0371C12.3946 18.8496 12.5 18.5952 12.5 18.33V10.33L14.7 18.55C14.7586 18.7682 14.8893 18.9601 15.0709 19.0945C15.2525 19.2288 15.4742 19.2978 15.7 19.29C15.7864 19.2999 15.8736 19.2999 15.96 19.29L20.79 18C20.9177 17.9659 21.0374 17.9068 21.1421 17.8261C21.2468 17.7454 21.3344 17.6448 21.4 17.53C21.5055 17.3088 21.5302 17.0576 21.47 16.82ZM5.47 17.37H2.47V15.37H5.47V17.37ZM5.47 13.37H2.47V7.37003H5.47V13.37ZM5.47 5.37003H2.47V3.37003H5.47V5.37003ZM10.47 17.37H7.47V15.37H10.47V17.37ZM10.47 13.37H7.47V7.37003H10.47V13.37ZM10.47 5.37003H7.47V3.37003H10.47V5.37003ZM12.72 3.63003L15.62 2.85003L16.14 4.78003L13.24 5.56003L12.72 3.63003ZM15.31 13.29L13.76 7.49003L16.66 6.71003L18.21 12.51L15.31 13.29ZM16.31 17.15L15.79 15.22L18.69 14.44L19.21 16.37L16.31 17.15Z" fill="#333333"/>
</svg> Módulos e Aulas
</div>
                <img src="@/assets/icons/arrow-navigate.svg" />
              </div>
            </router-link>
            <div class="lineDiv"></div>
            <router-link
              :to="'/config_curso/class/' + cursoAtual + ''"
              class="removeLink"
              :class="{ disableLink: existParans }"
            >
              <div class="spaceNav">
                <div class="text"><svg width="26" height="22" viewBox="0 0 26 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M24 20V18C23.9993 17.1137 23.7044 16.2528 23.1614 15.5523C22.6184 14.8519 21.8581 14.3516 21 14.13M18 20V18C18 16.9391 17.5786 15.9217 16.8284 15.1716C16.0783 14.4214 15.0609 14 14 14H6C4.93913 14 3.92172 14.4214 3.17157 15.1716C2.42143 15.9217 2 16.9391 2 18V20M17 2.13C17.8604 2.3503 18.623 2.8507 19.1676 3.55231C19.7122 4.25392 20.0078 5.11683 20.0078 6.005C20.0078 6.89317 19.7122 7.75608 19.1676 8.45769C18.623 9.1593 17.8604 9.6597 17 9.88M14 6C14 8.20914 12.2091 10 10 10C7.79086 10 6 8.20914 6 6C6 3.79086 7.79086 2 10 2C12.2091 2 14 3.79086 14 6Z" stroke="#333333" stroke-width="2.3" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
 Turmas</div>
                <img src="@/assets/icons/arrow-navigate.svg" />
              </div>
            </router-link>
            <div class="lineDiv"></div>
            <router-link
              :to="'/create-certificates/' + cursoAtual + ''"
              class="removeLink"
              :class="{ disableLink: existParans }"
            >
              <div class="spaceNav">
                <div class="text"><svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.43496 22.9609H16.6119H8.43496ZM12.5234 22.9609V16.4194V22.9609ZM19.065 10.6955C19.065 8.10753 19.0609 3.81517 19.0588 2.51862C19.0588 2.30175 18.9727 2.09377 18.8193 1.94042C18.666 1.78708 18.458 1.70093 18.2411 1.70093L6.80417 1.71422C6.58775 1.71421 6.38016 1.80001 6.22688 1.95281C6.07361 2.1056 5.98716 2.31293 5.98648 2.52935C5.98648 4.09216 5.97984 9.13067 5.97984 10.6955C5.97984 13.9806 10.2216 16.4194 12.5214 16.4194C14.8211 16.4194 19.065 13.9806 19.065 10.6955ZM19.065 10.6955C21.4388 10.6955 23.1534 7.79374 23.1534 4.97169V4.154H19.065V10.6955ZM5.98188 4.154H1.89343V4.97169C1.89343 7.79374 3.60803 10.6955 5.98188 10.6955V4.154Z" stroke="#333333" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
 Certificado</div>
                <img src="@/assets/icons/arrow-navigate.svg" />
              </div>
            </router-link>
            <div class="lineDiv"></div>
                                    <router-link
              :to="'/config_curso/vendas/'+cursoAtual+''"
              class="removeLink"
              :class="{ disableLink: existParans }"
            >
              <div class="spaceNav">
                <div class="text"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6 2L3 6V20C3 20.5304 3.21071 21.0391 3.58579 21.4142C3.96086 21.7893 4.46957 22 5 22H19C19.5304 22 20.0391 21.7893 20.4142 21.4142C20.7893 21.0391 21 20.5304 21 20V6L18 2H6Z" stroke="#333333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M16 10C16 11.0609 15.5786 12.0783 14.8284 12.8284C14.0783 13.5786 13.0609 14 12 14C10.9391 14 9.92172 13.5786 9.17157 12.8284C8.42143 12.0783 8 11.0609 8 10" stroke="#333333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M3 6H21" stroke="#333333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

  Vendas</div>
                <img src="@/assets/icons/arrow-navigate.svg" />
              </div>
            </router-link>
            <div class="lineDiv"></div>

            <div class="spaceBtn">
              <toggle-button :sync="true" 
              :labels="{checked: 'Ativo', unchecked: 'Inativo'}"
              @change="enventSwitchStatus"
              v-model="myDataVariable" />
            </div>
          </div>
        </b-col>
        <b-col cols="12" md="9" class="pt-5 spaceTop" data-anima="top">
          <div class="containerWizzard">
            <div class="title title-v2">Adicione o Certificado 
              <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.96177 29.7551H20.8644H9.96177ZM15.413 29.7551V21.0331V29.7551ZM24.135 13.4013C24.135 9.95067 24.1296 4.22752 24.1269 2.49879C24.1269 2.20963 24.0121 1.93232 23.8076 1.72786C23.6032 1.5234 23.3258 1.40854 23.0366 1.40854L7.7874 1.42624C7.49884 1.42624 7.22204 1.54064 7.01768 1.74438C6.81332 1.9481 6.69805 2.22454 6.69715 2.5131C6.69715 4.59684 6.68829 11.3149 6.68829 13.4013C6.68829 17.7815 12.344 21.0331 15.4104 21.0331C18.4766 21.0331 24.135 17.7815 24.135 13.4013ZM24.135 13.4013C27.3002 13.4013 29.5864 9.53228 29.5864 5.76955V4.6793H24.135V13.4013ZM6.69101 4.6793H1.23975V5.76955C1.23975 9.53228 3.52587 13.4013 6.69101 13.4013V4.6793Z" stroke="#333333" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
          </div>
          <div class="containerWizzardInputs">
            <div class="spaceInputs" v-if="midiacertifyurl === null">
              <b-form-group label="Modelo do Certificado" label-for="Modelo">
                <p class="textDimenssion">
                  Dimensão Recomendada: 1750x1240
                </p>
                <div class="btn-openModal" @click="showModalUploadCertify">
                  <p class="text">Clique e faça o Upload do Certificado do Curso</p>
                </div>
              </b-form-group>
            </div>
            <div class="spaceInputs" v-else>
              <div class="previewCertify">
                <div id="spaceText">
                    <VueDragResize ref="VueDragResize" w="auto" h="auto" :x="left" :y="top" :isActive="false" v-on:resizing="resize" v-on:dragging="resize" :isResizable="false" :isDraggable="true">
                        <p
                            class="nameText"
                            :style="
                            'cursor: grab; color:' +
                            color +
                            '; font-size:' +
                            fonteSize +
                            'px; line-height: normal; margin: 0; font-family:'+
                            fonteCertify+';'
                            "
                            id="nameText"
                        >
                            {{ nameCompleto }}
                        </p>
                    </VueDragResize>
                </div>
                <img
                  :src="midiacertifyurl"
                  alt="midiacertify"
                  id="photoX"
                />
              </div>
              <br>
              <p class="textDimenssion">
                  Dimensão Recomendada: 1750x1240
                </p>
              <b-form-group label="Modelo do Certificado" label-for="Modelo">
                <div class="btn-openModal" @click="showModalUploadCertify">
                  <p class="text">Clique e faça o Upload do Certificado do Curso</p>
                </div>
              </b-form-group>
              <div class="spaceInputsConfig">
                <b-form-group
                  label="Qual a fonte do Certificado"
                  label-for="fonte"
                >
                  <b-form-select
                    v-model="fonteCertify"
                    placeholder="Selecione uma Fonte"
                    :options="AllFontes"
                    value-field="id"
                    text-field="title"
                  ></b-form-select>
                </b-form-group>
              </div>
              <div>
                <b-form-group label="Tamanho da Fonte" label-for="name">
                  <b-form-input
                    id="rangeCards"
                    v-model="fonteSize"
                    type="range"
                    min="10"
                    max="100"
                    step="1"
                  ></b-form-input>
                  <p class="textPorcentage">{{ parseInt(fonteSize, 10) }}px</p>
                </b-form-group>
                <b-form-group label="Selecione a Porcentagem de Liberação de Certificado" label-for="name">
                  <b-form-input
                    id="rangeCards"
                    v-model="rangeCertify"
                    type="range"
                    min="0"
                    max="100"
                    step="1"
                  ></b-form-input>
                  <p class="textPorcentage">{{ rangeCertify }}%</p>
                </b-form-group>

                <b-form-group label="Cor da Fonte" label-for="name">
                  <v-swatches
                    v-model="color"
                    show-fallback
                    fallback-input-type="color"
                    inline
                  ></v-swatches>
                </b-form-group>
              </div>
            </div>

            <b-form-group v-if="midiacertifyurl !== null" label="Centralizar na Horizontal Automaticamente" label-for="name-module">
                <toggle-button
                  :sync="true"
                  v-model="centerName"
                />
              </b-form-group>

            <div class="spaceInputs" v-if="midiacertifyurl !== null">
              <button class="btn-criar mb-3" style="background: #ff0c37 !important; border:none !important;" @click.prevent="deleteCertify()">
                Deletar Certificado
                <svg
                  width="6"
                  height="10"
                  viewBox="0 0 6 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.0979614 9.01421C0.0979614 9.44138 0.59902 9.67184 0.923357 9.39384L5.4884 5.48095C5.7212 5.2814 5.7212 4.92124 5.4884 4.72169L0.923357 0.808801C0.59902 0.530798 0.0979614 0.761252 0.0979614 1.18843L0.0979614 9.01421Z"
                    fill="white"
                  />
                </svg>
              </button>
              <button class="btn-criar mb-3" @click.prevent="salveCertify('test')">
                Salvar e Baixar como Teste
                <svg
                  width="6"
                  height="10"
                  viewBox="0 0 6 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.0979614 9.01421C0.0979614 9.44138 0.59902 9.67184 0.923357 9.39384L5.4884 5.48095C5.7212 5.2814 5.7212 4.92124 5.4884 4.72169L0.923357 0.808801C0.59902 0.530798 0.0979614 0.761252 0.0979614 1.18843L0.0979614 9.01421Z"
                    fill="white"
                  />
                </svg>
              </button>
              <button class="btn-criar" @click.prevent="salveCertify()">
                Salvar Certificado
                <svg
                  width="6"
                  height="10"
                  viewBox="0 0 6 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.0979614 9.01421C0.0979614 9.44138 0.59902 9.67184 0.923357 9.39384L5.4884 5.48095C5.7212 5.2814 5.7212 4.92124 5.4884 4.72169L0.923357 0.808801C0.59902 0.530798 0.0979614 0.761252 0.0979614 1.18843L0.0979614 9.01421Z"
                    fill="white"
                  />
                </svg>
              </button>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
  <div class="createCertifyzz" v-else>
    <modal-upload></modal-upload>
    <div class="container">
      <b-row class="spaceAddCertify">

        <b-col cols="12" md="3" class="pt-5" data-anima="top">
          <div class="navigate">
            <div class="title">{{ nameCourse }}
              <button id="viewModuleLesson" class="viewModuleLesson" @click="viewCourse()">
                  Ver Curso
                  <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.375 8.75L12.5 5.625L9.375 2.5" stroke="#C4C4C4" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M2.5 12.5V8.125C2.5 7.46194 2.76339 6.82606 3.23223 6.35725C3.70107 5.88839 4.33696 5.625 5 5.625H12.5" stroke="#C4C4C4" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              </button>
            </div>
            <div class="lineDiv"></div>
            <router-link :to="'/config_curso/' + cursoAtual" class="removeLink">
              <div class="spaceNav">
                <div class="text"><svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M17 0H3C2.20435 0 1.44129 0.316071 0.87868 0.87868C0.316071 1.44129 0 2.20435 0 3V11C0 11.7956 0.316071 12.5587 0.87868 13.1213C1.44129 13.6839 2.20435 14 3 14H9V16H5C4.73478 16 4.48043 16.1054 4.29289 16.2929C4.10536 16.4804 4 16.7348 4 17C4 17.2652 4.10536 17.5196 4.29289 17.7071C4.48043 17.8946 4.73478 18 5 18H15C15.2652 18 15.5196 17.8946 15.7071 17.7071C15.8946 17.5196 16 17.2652 16 17C16 16.7348 15.8946 16.4804 15.7071 16.2929C15.5196 16.1054 15.2652 16 15 16H11V14H17C17.7956 14 18.5587 13.6839 19.1213 13.1213C19.6839 12.5587 20 11.7956 20 11V3C20 2.20435 19.6839 1.44129 19.1213 0.87868C18.5587 0.316071 17.7956 0 17 0ZM18 11C18 11.2652 17.8946 11.5196 17.7071 11.7071C17.5196 11.8946 17.2652 12 17 12H3C2.73478 12 2.48043 11.8946 2.29289 11.7071C2.10536 11.5196 2 11.2652 2 11V3C2 2.73478 2.10536 2.48043 2.29289 2.29289C2.48043 2.10536 2.73478 2 3 2H17C17.2652 2 17.5196 2.10536 17.7071 2.29289C17.8946 2.48043 18 2.73478 18 3V11Z" fill="#333333"/>
</svg>
 Dados do Curso
</div>
                <img src="@/assets/icons/arrow-navigate.svg" />
              </div>
            </router-link>
            <div class="lineDiv"></div>
            <router-link
              :to="'/config_curso/' + cursoAtual + '/module'"
              class="removeLink"
              :class="{ disableLink: existParans }"
            >
              <div class="spaceNav">
                <div class="text"><svg width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M21.47 16.82L20.47 12.96L17.32 1.37003C17.2519 1.11437 17.0853 0.896104 16.8567 0.76303C16.628 0.629955 16.3559 0.592918 16.1 0.66003L12.23 1.66003C12.1376 1.55767 12.0251 1.47552 11.8995 1.41873C11.7739 1.36194 11.6379 1.33174 11.5 1.33003H1.5C1.23478 1.33003 0.98043 1.43539 0.792893 1.62292C0.605357 1.81046 0.5 2.06481 0.5 2.33003V18.33C0.5 18.5952 0.605357 18.8496 0.792893 19.0371C0.98043 19.2247 1.23478 19.33 1.5 19.33H11.5C11.7652 19.33 12.0196 19.2247 12.2071 19.0371C12.3946 18.8496 12.5 18.5952 12.5 18.33V10.33L14.7 18.55C14.7586 18.7682 14.8893 18.9601 15.0709 19.0945C15.2525 19.2288 15.4742 19.2978 15.7 19.29C15.7864 19.2999 15.8736 19.2999 15.96 19.29L20.79 18C20.9177 17.9659 21.0374 17.9068 21.1421 17.8261C21.2468 17.7454 21.3344 17.6448 21.4 17.53C21.5055 17.3088 21.5302 17.0576 21.47 16.82ZM5.47 17.37H2.47V15.37H5.47V17.37ZM5.47 13.37H2.47V7.37003H5.47V13.37ZM5.47 5.37003H2.47V3.37003H5.47V5.37003ZM10.47 17.37H7.47V15.37H10.47V17.37ZM10.47 13.37H7.47V7.37003H10.47V13.37ZM10.47 5.37003H7.47V3.37003H10.47V5.37003ZM12.72 3.63003L15.62 2.85003L16.14 4.78003L13.24 5.56003L12.72 3.63003ZM15.31 13.29L13.76 7.49003L16.66 6.71003L18.21 12.51L15.31 13.29ZM16.31 17.15L15.79 15.22L18.69 14.44L19.21 16.37L16.31 17.15Z" fill="#333333"/>
</svg> Módulos e Aulas
</div>
                <img src="@/assets/icons/arrow-navigate.svg" />
              </div>
            </router-link>
            <div class="lineDiv"></div>
            <router-link
              :to="'/config_curso/class/' + cursoAtual + ''"
              class="removeLink"
              :class="{ disableLink: existParans }"
            >
              <div class="spaceNav">
                <div class="text"><svg width="26" height="22" viewBox="0 0 26 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M24 20V18C23.9993 17.1137 23.7044 16.2528 23.1614 15.5523C22.6184 14.8519 21.8581 14.3516 21 14.13M18 20V18C18 16.9391 17.5786 15.9217 16.8284 15.1716C16.0783 14.4214 15.0609 14 14 14H6C4.93913 14 3.92172 14.4214 3.17157 15.1716C2.42143 15.9217 2 16.9391 2 18V20M17 2.13C17.8604 2.3503 18.623 2.8507 19.1676 3.55231C19.7122 4.25392 20.0078 5.11683 20.0078 6.005C20.0078 6.89317 19.7122 7.75608 19.1676 8.45769C18.623 9.1593 17.8604 9.6597 17 9.88M14 6C14 8.20914 12.2091 10 10 10C7.79086 10 6 8.20914 6 6C6 3.79086 7.79086 2 10 2C12.2091 2 14 3.79086 14 6Z" stroke="#333333" stroke-width="2.3" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
 Turmas</div>
                <img src="@/assets/icons/arrow-navigate.svg" />
              </div>
            </router-link>
            <div class="lineDiv"></div>
            <router-link
              :to="'/create-certificates/' + cursoAtual + ''"
              class="removeLink"
              :class="{ disableLink: existParans }"
            >
              <div class="spaceNav">
                <div class="text"><svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.43496 22.9609H16.6119H8.43496ZM12.5234 22.9609V16.4194V22.9609ZM19.065 10.6955C19.065 8.10753 19.0609 3.81517 19.0588 2.51862C19.0588 2.30175 18.9727 2.09377 18.8193 1.94042C18.666 1.78708 18.458 1.70093 18.2411 1.70093L6.80417 1.71422C6.58775 1.71421 6.38016 1.80001 6.22688 1.95281C6.07361 2.1056 5.98716 2.31293 5.98648 2.52935C5.98648 4.09216 5.97984 9.13067 5.97984 10.6955C5.97984 13.9806 10.2216 16.4194 12.5214 16.4194C14.8211 16.4194 19.065 13.9806 19.065 10.6955ZM19.065 10.6955C21.4388 10.6955 23.1534 7.79374 23.1534 4.97169V4.154H19.065V10.6955ZM5.98188 4.154H1.89343V4.97169C1.89343 7.79374 3.60803 10.6955 5.98188 10.6955V4.154Z" stroke="#333333" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
 Certificado</div>
                <img src="@/assets/icons/arrow-navigate.svg" />
              </div>
            </router-link>

            <div class="lineDiv"></div>
                                    <router-link
              :to="'/config_curso/vendas/'+cursoAtual+''"
              class="removeLink"
              :class="{ disableLink: existParans }"
            >
              <div class="spaceNav">
                <div class="text"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6 2L3 6V20C3 20.5304 3.21071 21.0391 3.58579 21.4142C3.96086 21.7893 4.46957 22 5 22H19C19.5304 22 20.0391 21.7893 20.4142 21.4142C20.7893 21.0391 21 20.5304 21 20V6L18 2H6Z" stroke="#333333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M16 10C16 11.0609 15.5786 12.0783 14.8284 12.8284C14.0783 13.5786 13.0609 14 12 14C10.9391 14 9.92172 13.5786 9.17157 12.8284C8.42143 12.0783 8 11.0609 8 10" stroke="#333333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M3 6H21" stroke="#333333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

  Vendas</div>
                <img src="@/assets/icons/arrow-navigate.svg" />
              </div>
            </router-link>
            <div class="lineDiv"></div>

            <div class="spaceBtn">
              <toggle-button :sync="true" 
              :labels="{checked: 'Ativo', unchecked: 'Inativo'}"
              @change="enventSwitchStatus"
              v-model="myDataVariable" />
            </div>
          </div>
        </b-col>
        <b-col cols="12" md="9" class="pt-5 spaceTop" data-anima="top">
          <div class="containerWizzard">
            <div class="title">Adicione o Certificado 
              <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.96177 29.7551H20.8644H9.96177ZM15.413 29.7551V21.0331V29.7551ZM24.135 13.4013C24.135 9.95067 24.1296 4.22752 24.1269 2.49879C24.1269 2.20963 24.0121 1.93232 23.8076 1.72786C23.6032 1.5234 23.3258 1.40854 23.0366 1.40854L7.7874 1.42624C7.49884 1.42624 7.22204 1.54064 7.01768 1.74438C6.81332 1.9481 6.69805 2.22454 6.69715 2.5131C6.69715 4.59684 6.68829 11.3149 6.68829 13.4013C6.68829 17.7815 12.344 21.0331 15.4104 21.0331C18.4766 21.0331 24.135 17.7815 24.135 13.4013ZM24.135 13.4013C27.3002 13.4013 29.5864 9.53228 29.5864 5.76955V4.6793H24.135V13.4013ZM6.69101 4.6793H1.23975V5.76955C1.23975 9.53228 3.52587 13.4013 6.69101 13.4013V4.6793Z" stroke="#333333" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
          </div>
          <div class="containerWizzardInputs">
            <div class="spaceInputs" v-if="midiacertifyurl === null">
              <b-form-group label="Modelo do Certificado" label-for="Modelo">
                <p class="textDimenssion">
                  Dimensão Recomendada: 1750x1240
                </p>
                <div class="btn-openModal" @click="showModalUploadCertify">
                  <p class="text">Clique e faça o Upload do Certificado do Curso</p>
                </div>
              </b-form-group>
            </div>
            <div class="spaceInputs" v-else>
              <div class="previewCertify">
                <div id="spaceText">
                    <VueDragResize ref="VueDragResize" w="auto" h="auto" :x="left" :y="top" :isActive="false" v-on:resizing="resize" v-on:dragging="resize" :isResizable="false" :isDraggable="true">
                        <p
                            class="nameText"
                            :style="
                            'cursor: grab; color:' +
                            color +
                            '; font-size:' +
                            fonteSize +
                            'px; line-height: normal; margin: 0; font-family:'+
                            fonteCertify+';'
                            "
                            id="nameText"
                        >
                            {{ nameCompleto }}
                        </p>
                    </VueDragResize>
                </div>
                <img
                  :src="midiacertifyurl"
                  alt="midiacertify"
                  id="photoX"
                />
              </div>
              <br>
              <p class="textDimenssion">
                  Dimensão Recomendada: 1750x1240
                </p>
              <b-form-group label="Modelo do Certificado" label-for="Modelo">
                <div class="btn-openModal" @click="showModalUploadCertify">
                  <p class="text">Clique e faça o Upload do Certificado do Curso</p>
                </div>
              </b-form-group>
              <div class="spaceInputsConfig">
                <b-form-group
                  label="Qual a fonte do Certificado"
                  label-for="fonte"
                >
                  <b-form-select
                    v-model="fonteCertify"
                    placeholder="Selecione uma Fonte"
                    :options="AllFontes"
                    value-field="id"
                    text-field="title"
                  ></b-form-select>
                </b-form-group>
              </div>
              <div>
                <b-form-group label="Tamanho da Fonte" label-for="name">
                  <b-form-input
                    id="rangeCards"
                    v-model="fonteSize"
                    type="range"
                    min="10"
                    max="100"
                    step="1"
                  ></b-form-input>
                  <p class="textPorcentage">{{ parseInt(fonteSize, 10) }}px</p>
                </b-form-group>
                <b-form-group label="Selecione a Porcentagem de Liberação de Certificado" label-for="name">
                  <b-form-input
                    id="rangeCards"
                    v-model="rangeCertify"
                    type="range"
                    min="0"
                    max="100"
                    step="1"
                  ></b-form-input>
                  <p class="textPorcentage">{{ rangeCertify }}%</p>
                </b-form-group>

                <b-form-group label="Cor da Fonte" label-for="name">
                  <v-swatches
                    v-model="color"
                    show-fallback
                    fallback-input-type="color"
                    inline
                  ></v-swatches>
                </b-form-group>
              </div>

            </div>

            <b-form-group v-if="midiacertifyurl !== null" label="Centralizar na Horizontal Automaticamente" label-for="name-module">
                <toggle-button
                  :sync="true"
                  v-model="centerName"
                />
              </b-form-group>

            <div class="spaceInputs" v-if="midiacertifyurl !== null">
              <button class="btn-criar mb-3" style="background: #ff0c37 !important; border:none !important;" @click.prevent="deleteCertify()">
                Deletar Certificado
                <svg
                  width="6"
                  height="10"
                  viewBox="0 0 6 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.0979614 9.01421C0.0979614 9.44138 0.59902 9.67184 0.923357 9.39384L5.4884 5.48095C5.7212 5.2814 5.7212 4.92124 5.4884 4.72169L0.923357 0.808801C0.59902 0.530798 0.0979614 0.761252 0.0979614 1.18843L0.0979614 9.01421Z"
                    fill="white"
                  />
                </svg>
              </button>
              <button class="btn-criar mb-3" @click.prevent="salveCertify('test')">
                Salvar e Baixar como Teste
                <svg
                  width="6"
                  height="10"
                  viewBox="0 0 6 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.0979614 9.01421C0.0979614 9.44138 0.59902 9.67184 0.923357 9.39384L5.4884 5.48095C5.7212 5.2814 5.7212 4.92124 5.4884 4.72169L0.923357 0.808801C0.59902 0.530798 0.0979614 0.761252 0.0979614 1.18843L0.0979614 9.01421Z"
                    fill="white"
                  />
                </svg>
              </button>
              <button class="btn-criar" @click.prevent="salveCertify()">
                Salvar Certificado
                <svg
                  width="6"
                  height="10"
                  viewBox="0 0 6 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.0979614 9.01421C0.0979614 9.44138 0.59902 9.67184 0.923357 9.39384L5.4884 5.48095C5.7212 5.2814 5.7212 4.92124 5.4884 4.72169L0.923357 0.808801C0.59902 0.530798 0.0979614 0.761252 0.0979614 1.18843L0.0979614 9.01421Z"
                    fill="white"
                  />
                </svg>
              </button>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
import ModalUpload from "@/components/ModalUpload.vue";
import CourseService from "@/services/resources/CourseService";
const serviceCourse = CourseService.build();
import "vue-swatches/dist/vue-swatches.css"
import notify from "@/services/libs/notificacao";
import CustomFieldsService from "@/services/resources/CustomFieldsService";
const service = CustomFieldsService.build();
import axios from "axios";
import Cookies from 'js-cookie';
import VueDragResize from 'vue-drag-resize';
import VSwatches from 'vue-swatches';

export default {
  components: {
    ModalUpload,
    VSwatches,
    VueDragResize,
  },
  data() {
    return {
      courseSelect: 1,
      AllCourse: "",
      data: "",
      nameCourse: "",
      myDataVariable: true,
      cursoAtual: "",
      existParans: false,
      midiacertifyurl: null,
      midiacertify: null,
      nameCompleto: "Nome do Aluno",
      fonteCertify: "Anton",
      AllFontes: [
        'Anton', 'Architects Daughter', 'Cabin Condensed', 'Caveat', 'Dancing Script', 'Gloria Hallelujah', 'Great Vibes', 'Lobster', 'Noto Sans JP', 'Open Sans Condensed', 'Oswald',  'Pacifico', 'Roboto', 'Roboto Mono',
      ],
      fonteSize: 28,
      color: '#000',
      width: 0,
      height: 0,
      top: 400,
      left: 0,
      eixoX:0,
      eixoY:0,

      top2: 400,
      left2: 0,
      eixoX2:0,
      eixoY2:0,

      certifyId: null,
      rangeCertify:75,
      customInputs:null,
      optionsLessonCategory:[],
      centerName:false,
      notexist:null,
    };
  },
  computed: {
    theme() {
      return this.$store.state.globalSettings.theme;
    },
    clubVersion() {
      return this.$store.state.globalSettings.clubVersion;
    },
  },
  methods: {
    deleteCertify(){
      if(this.notexist === true){
          this.midiacertifyurl = null;
          this.certifyId = null;
          notify("sucesso", "Certificado removido com Sucesso!");
      }else{
        serviceCourse
          .destroy(this.cursoAtual+"/certificate")
          .then((resp) => {
            //console.log("delete certify", resp);
            this.getDataParams();
            this.getCustoms();
            this.certifyId = null;
            this.midiacertifyurl = null;
            notify("sucesso", "Certificado deletado com Sucesso!");
          })
          .catch((err) => {
            //console.log(err);
            notify("erro", "Erro ao Deletar Certificado!");
            this.midiacertifyurl = null;
          });
      }
    },
    selectItem(e){
      //console.log(e)
      this.customInputs = e;
    },
     customLabel({ text }) {
      return `${text}`
    },
    getCustoms(){
        service
        .search()
        .then((resp) => {
        //console.log("get-fields", resp);
        resp.forEach((item) => {
            this.optionsLessonCategory.push({
                value: item.id,
                text: item.name,
            });
            });
        })
        .catch((err) => {
            //console.log(err);
        });
    },
    viewCourse(){
      serviceCourse
      .read(this.cursoAtual+'/module')
      .then(resp => {
        //console.log("get modules", resp);
        if(resp.length === 0){
          notify('erro', 'Nenhum Módulo Configurado!')
          return false;
        }
        let routeData = this.$router.resolve('/curso/'+this.cursoAtual);
        window.open(routeData.href, '_blank');
      })
    },
    enventSwitchStatus() {
      var xxxStatus = ''
      if (this.myDataVariable === true) {
        xxxStatus = "published";
      } else {
        xxxStatus = "draft";
      }
      let data = {
        id: this.cursoAtual,
        status: xxxStatus,
      };
      //console.log(data);
      this.$root.$emit('loadOn');
      serviceCourse
        .postID({ id: this.cursoAtual, status: xxxStatus })
        .then((resp) => {
          this.$root.$emit('loadOff');
          //console.log("update course status", resp);
          this.getCourse();
        })
        .catch((err) => {
          //console.log(err);
          this.$root.$emit('loadOff');
        });
    },
    salveCertify(test){
        var width = document.getElementById('photoX').clientWidth; 
        var height = document.getElementById('photoX').clientHeight; 
        var x = document.getElementById("photoX").naturalWidth;
        var y = document.getElementById("photoX").naturalHeight;
        var size = this.fonteSize;
        var eixoX = this.left;
        var eixoY = this.top;

        eixoY = eixoY - ((this.$store.getters.currentSite.currentSite.id == 438 || 1092) ? 86 : 46);
        eixoX = eixoX-30;
        size = size-5;
        //console.log(width, x, eixoX);
        var somaWidth = x / width;
        var somaHeight = y / height;

        var resultX = eixoX * somaWidth;
        var resulty = eixoY * somaHeight;
        var fontSize = size * somaWidth;

        resulty = resulty - document.querySelector('#nameText').offsetHeight;

        if(this.certifyId === null || this.certifyId === undefined){
          let data = {
            id: this.cursoAtual+'/certificate',
            position_x: parseInt(resultX, 10),
            position_y: parseInt(resulty, 10),
            font_size: fontSize,
            font_color: this.color,
            font: this.fonteCertify,
            media_id: this.midiacertify,
            percentage: parseInt(this.rangeCertify, 10),
          };

          if(this.centerName){
            data.center_horizontal = 'on';
          }else{
            data.center_horizontal = 'off';
          }

          serviceCourse
          .postID(data)
          .then((resp) => {
            //console.log("create certify", resp);
            notify('sucesso', 'Certificado Salvo com Sucesso!');
            if(test){
              this.testCerify();
            }
            this.getCertify();
          })
          .catch((err) => {
            notify('erro', 'Erro ao criar Certificado!');
            //console.log(err);
          });
        }else{
          let data = {
            id: this.cursoAtual+'/certificate/update',
            position_x: parseInt(resultX, 10),
            position_y: parseInt(resulty, 10),
            font_size: fontSize,
            font_color: this.color,
            font: this.fonteCertify,
            media_id: this.midiacertify,
            percentage: parseInt(this.rangeCertify, 10),
          };

          if(this.centerName){
            data.center_horizontal = 'on';
          }else{
            data.center_horizontal = 'off';
          }

          //console.log(data);
          serviceCourse
          .postID(data)
          .then((resp) => {
            //console.log("update certify", resp);
            notify('sucesso', 'Certificado Atualizado com Sucesso!');
            if(test){
              this.testCerify();
            }
            this.getCertify();
          })
          .catch((err) => {
            notify('erro', 'Erro ao Atualizar Certificado!');
            //console.log(err);
          });
        }
    },
    testCerify(){
      axios({
          url: process.env.VUE_APP_API_HOST+`/course/${this.cursoAtual}/certificate/test`,
          method: "GET",
          responseType: "blob",
          headers: {
          'Authorization': Cookies.get('auth_greennCourse')
          }
      }).then((response) => {
          // var fileURL = window.URL.createObjectURL(new Blob([response.data], {type: "application/pdf"}));
          var fileURL = window.URL.createObjectURL(new Blob([response.data], {type: "image/jpeg"}));
          const fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.setAttribute("download", `Certificado-${this.nameCourse}`);
          document.body.appendChild(fileLink);
          fileLink.click();
      });
    },
    resize(newRect) {
        this.width = newRect.width;
        this.height = newRect.height;
        this.top = newRect.top;
        this.left = newRect.left;
    },
    resize2(newRect) {
        this.width2 = newRect.width;
        this.height2 = newRect.height;
        this.top2 = newRect.top;
        this.left2 = newRect.left;
    },
    getCourse() {
      let data = {
        id: this.cursoAtual,
      };
      serviceCourse
        .read(data)
        .then((resp) => {
          //console.log("get course", resp);
          this.AllCourse = resp.data;
          this.nameCourse = resp.title;
        })
        .catch((err) => {
          //console.log(err);
        });
    },
    getCertify(mounted){
        serviceCourse
        .read(this.cursoAtual+'/certificate')
        .then(resp => {
            // console.log("certify data", resp);
            if(JSON.stringify(resp) !== "{}"){
              this.notexist = false;
              this.certifyId = resp.id;
              this.midiacertify = resp.media.id;
              this.midiacertifyurl = resp.media.cdn_url;
              this.rangeCertify = resp.percentage;
              if (this.$refs.VueDragResize && this.$refs.VueDragResize.top) {
                this.$refs.VueDragResize.top = this.$refs.VueDragResize.top + 31;  
              }
              setTimeout(() => {
                var width = document.getElementById('photoX').clientWidth; 
                var height = document.getElementById('photoX').clientHeight; 
                var x = document.getElementById("photoX").naturalWidth;
                var y = document.getElementById("photoX").naturalHeight;
                var somaWidth = x / width;
                var metaMidia = resp.media.media_meta;

                for (let i = 0; i < metaMidia.length; i++) {
                  const meta = metaMidia[i];
                  if(meta.key === 'font_size'){
                    var lastResultF = meta.value;
                    var lastResultF = lastResultF;
                    var resultF = lastResultF/somaWidth;
                    this.fonteSize = resultF + 5;
                  }
                }
                
                for (let i = 0; i < metaMidia.length; i++) {
                  const meta = metaMidia[i];
                  if(meta.key === 'position_x'){
                    var lastResultX =  parseInt( meta.value, 10);
                    var resultX = (lastResultX*width)/x;
                    this.left = parseInt(resultX, 10) + 31;
                    this.$refs.VueDragResize.left = parseInt(resultX, 10) + 31;
                  }else if(meta.key === 'position_y'){
                    var lastResultY = parseInt( meta.value, 10);
                    lastResultY = lastResultY + document.querySelector('#nameText').offsetHeight;
                    var resultY = (lastResultY*height)/y;
                    if(mounted){
                      this.top = parseInt(resultY, 10) + ((this.$store.getters.currentSite.currentSite.id == 438 || 1092) ? 87 : 56);
                      this.$refs.VueDragResize.top = parseInt(resultY, 10) + 87;
                    }else{
                      this.top = parseInt(resultY, 10) + 47;
                      this.$refs.VueDragResize.top = parseInt(resultY, 10) + 127;
                    }
                  }else if(meta.key === 'font_size'){
                    var lastResultF = meta.value;
                    var lastResultF = lastResultF;
                    var resultF = lastResultF/somaWidth;
                    this.fonteSize = resultF + 5;
                  }else if(meta.key === 'font_color'){
                      this.color = meta.value;
                  }else if(meta.key === 'font'){
                    this.fonteCertify = meta.value;
                  }else if(meta.key === 'center_horizontal'){
                    if(meta.value === "on"){
                      this.centerName = true;
                    }else{
                      this.centerName = false;
                    }
                  }
                }
                //console.log('yyyyyyy', this.customInputs, this.optionsLessonCategory, this.top, this.$refs.VueDragResize);
              }, 1000);
            }else{
              this.notexist = true;
            }
        }).catch(err => {
            //console.log(err);
        }); 
    },
    getDataParams() {
      const params = this.$route.params.curso;
      //console.log(params);
      if (params === null || params === undefined || params === "") {
        this.$router.push("/course");
      } else {
        this.cursoAtual = params;
        this.existParans = false;
        this.getCourse();
        this.getCertify('mounted');
        if (this.$refs.VueDragResize && this.$refs.VueDragResize.top) {
          this.$refs.VueDragResize.top = this.$refs.VueDragResize.top + 31;  
        }
      }
    },
    showModalUploadCertify() {
      this.$root.$emit("certify");
      this.$root.$emit("bv::show::modal", "modal-upload", "#btnShow");
    },
  },
  mounted() {
    this.getDataParams();
    this.getCustoms();
    this.$root.$on("midiacertify", (data) => {
      this.midiacertify = parseInt(data.id);
      this.midiacertifyurl = data.url;
    });
  },
};
</script>
<style lang="scss">

.title-v2{
  font-family: "Montserrat Alternates" !important; 
  font-style: normal !important;
  font-weight: 800 !important;
}

fieldset[disabled] .multiselect{pointer-events:none}.multiselect__spinner{position:absolute;right:1px;top:1px;width:48px;height:35px;background:#fff;display:block}.multiselect__spinner:after,.multiselect__spinner:before{position:absolute;content:"";top:50%;left:50%;margin:-8px 0 0 -8px;width:16px;height:16px;border-radius:100%;border:2px solid transparent;border-top-color:#41b883;box-shadow:0 0 0 1px transparent}.multiselect__spinner:before{animation:spinning 2.4s cubic-bezier(.41,.26,.2,.62);animation-iteration-count:infinite}.multiselect__spinner:after{animation:spinning 2.4s cubic-bezier(.51,.09,.21,.8);animation-iteration-count:infinite}.multiselect__loading-enter-active,.multiselect__loading-leave-active{transition:opacity .4s ease-in-out;opacity:1}.multiselect__loading-enter,.multiselect__loading-leave-active{opacity:0}.multiselect,.multiselect__input,.multiselect__single{font-family:inherit;font-size:16px;-ms-touch-action:manipulation;touch-action:manipulation}.multiselect{box-sizing:content-box;display:block;position:relative;width:100%;min-height:40px;text-align:left;color:#35495e}.multiselect *{box-sizing:border-box}.multiselect:focus{outline:none}.multiselect--disabled{background:#ededed;pointer-events:none;opacity:.6}.multiselect--active{z-index:50}.multiselect--active:not(.multiselect--above) .multiselect__current,.multiselect--active:not(.multiselect--above) .multiselect__input,.multiselect--active:not(.multiselect--above) .multiselect__tags{border-bottom-left-radius:0;border-bottom-right-radius:0}.multiselect--active .multiselect__select{transform:rotate(180deg)}.multiselect--above.multiselect--active .multiselect__current,.multiselect--above.multiselect--active .multiselect__input,.multiselect--above.multiselect--active .multiselect__tags{border-top-left-radius:0;border-top-right-radius:0}.multiselect__input,.multiselect__single{position:relative;display:inline-block;min-height:20px;line-height:20px;border:none;border-radius:5px;background:#fff;padding:0 0 0 5px;width:100%;transition:border .1s ease;box-sizing:border-box;margin-bottom:8px;vertical-align:top}.multiselect__input:-ms-input-placeholder{color:#35495e}.multiselect__input::placeholder{color:#35495e}.multiselect__tag~.multiselect__input,.multiselect__tag~.multiselect__single{width:auto}.multiselect__input:hover,.multiselect__single:hover{border-color:#cfcfcf}.multiselect__input:focus,.multiselect__single:focus{border-color:#a8a8a8;outline:none}.multiselect__single{padding-left:5px;margin-bottom:8px}.multiselect__tags-wrap{display:inline}.multiselect__tags{min-height:40px;display:block;padding:8px 40px 0 8px;border-radius:5px;border:1px solid #e8e8e8;background:#fff;font-size:14px}.multiselect__tag{position:relative;display:inline-block;padding:4px 26px 4px 10px;border-radius:5px;margin-right:10px;color:#fff;line-height:1;background:#41b883;margin-bottom:5px;white-space:nowrap;overflow:hidden;max-width:100%;text-overflow:ellipsis}.multiselect__tag-icon{cursor:pointer;margin-left:7px;position:absolute;right:0;top:0;bottom:0;font-weight:700;font-style:normal;width:22px;text-align:center;line-height:22px;transition:all .2s ease;border-radius:5px}.multiselect__tag-icon:after{content:"\D7";color:#266d4d;font-size:14px}.multiselect__tag-icon:focus,.multiselect__tag-icon:hover{background:#369a6e}.multiselect__tag-icon:focus:after,.multiselect__tag-icon:hover:after{color:#fff}.multiselect__current{min-height:40px;overflow:hidden;padding:8px 30px 0 12px;white-space:nowrap;border-radius:5px;border:1px solid #e8e8e8}.multiselect__current,.multiselect__select{line-height:16px;box-sizing:border-box;display:block;margin:0;text-decoration:none;cursor:pointer}.multiselect__select{position:absolute;width:40px;height:38px;right:1px;top:1px;padding:4px 8px;text-align:center;transition:transform .2s ease}.multiselect__select:before{position:relative;right:0;top:65%;color:#999;margin-top:4px;border-color:#999 transparent transparent;border-style:solid;border-width:5px 5px 0;content:""}.multiselect__placeholder{color:#adadad;display:inline-block;margin-bottom:10px;padding-top:2px}.multiselect--active .multiselect__placeholder{display:none}.multiselect__content-wrapper{position:absolute;display:block;background:#fff;width:100%;max-height:240px;overflow:auto;border:1px solid #e8e8e8;border-top:none;border-bottom-left-radius:5px;border-bottom-right-radius:5px;z-index:50;-webkit-overflow-scrolling:touch}.multiselect__content{list-style:none;display:inline-block;padding:0;margin:0;min-width:100%;vertical-align:top}.multiselect--above .multiselect__content-wrapper{bottom:100%;border-bottom-left-radius:0;border-bottom-right-radius:0;border-top-left-radius:5px;border-top-right-radius:5px;border-bottom:none;border-top:1px solid #e8e8e8}.multiselect__content::webkit-scrollbar{display:none}.multiselect__element{display:block}.multiselect__option{display:block;padding:12px;min-height:40px;line-height:16px;text-decoration:none;text-transform:none;vertical-align:middle;position:relative;cursor:pointer;white-space:nowrap}.multiselect__option:after{top:0;right:0;position:absolute;line-height:40px;padding-right:12px;padding-left:20px;font-size:13px}.multiselect__option--highlight{background:#41b883;outline:none;color:#fff}.multiselect__option--highlight:after{content:attr(data-select);background:#41b883;color:#fff}.multiselect__option--selected{background:#f3f3f3;color:#35495e;font-weight:700}.multiselect__option--selected:after{content:attr(data-selected);color:silver}.multiselect__option--selected.multiselect__option--highlight{background:#ff6a6a;color:#fff}.multiselect__option--selected.multiselect__option--highlight:after{background:#ff6a6a;content:attr(data-deselect);color:#fff}.multiselect--disabled .multiselect__current,.multiselect--disabled .multiselect__select{background:#ededed;color:#a6a6a6}.multiselect__option--disabled{background:#ededed!important;color:#a6a6a6!important;cursor:text;pointer-events:none}.multiselect__option--group{background:#ededed;color:#35495e}.multiselect__option--group.multiselect__option--highlight{background:#35495e;color:#fff}.multiselect__option--group.multiselect__option--highlight:after{background:#35495e}.multiselect__option--disabled.multiselect__option--highlight{background:#dedede}.multiselect__option--group-selected.multiselect__option--highlight{background:#ff6a6a;color:#fff}.multiselect__option--group-selected.multiselect__option--highlight:after{background:#ff6a6a;content:attr(data-deselect);color:#fff}.multiselect-enter-active,.multiselect-leave-active{transition:all .15s ease}.multiselect-enter,.multiselect-leave-active{opacity:0}.multiselect__strong{margin-bottom:8px;line-height:20px;display:inline-block;vertical-align:top}[dir=rtl] .multiselect{text-align:right}[dir=rtl] .multiselect__select{right:auto;left:1px}[dir=rtl] .multiselect__tags{padding:8px 8px 0 40px}[dir=rtl] .multiselect__content{text-align:right}[dir=rtl] .multiselect__option:after{right:auto;left:0}[dir=rtl] .multiselect__clear{right:auto;left:12px}[dir=rtl] .multiselect__spinner{right:auto;left:1px}@keyframes spinning{0%{transform:rotate(0)}to{transform:rotate(2turn)}}
.createCertifyzz {
  .textPorcentage{
    font-family: Montserrat;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    color: #000000;
    margin-top:-10px;
  }
  .spaceInputsConfig {
    margin-top: 20px;
    .multiselect__tags {
    padding: 16px 40px 0 8px !important;
    height: 55px !important;
}
    .multiselect__single {
    padding-left: 5px;
    margin-bottom: 8px;
    font-family: Montserrat;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    color: #000000;
}
input, select,
        textarea {
          border: 1px solid var(--bordercolor);
          box-sizing: border-box;
          border-radius: 5px;
          height: 55px;
          font-family: Montserrat;
          font-style: normal;
          font-weight: 600;
          font-size: 14px;
          color: #000000;
          overflow: hidden !important;
          resize: none !important;
        }
        input:hover,
        select:hover,
        textarea:hover,
        input:focus,
        select:focus,
        textarea:focus {
          border: 1px solid var(--maincolor);
          box-shadow: 0px 4px 10px rgba(3, 148, 105, 0.03);
          font-family: Montserrat;
          font-style: normal;
          font-weight: 600;
          font-size: 14px;
          color: #000000;
        }
        label {
          font-family: Montserrat;
          font-style: normal;
          font-weight: 600;
          font-size: 14px;
          color: var(--fontcolor2);
        }
  }
  .removeLink {
    text-decoration: none;
  }
  .navigate {
    .title {
      font-family: Montserrat;
      font-style: normal;
      font-weight: 800;
      font-size: 18px;
      color: var(--fontcolor);
      word-break: break-all;
    }
    .lineDiv {
      width: 100%;
      margin-top: 20px;
      margin-bottom: 20px;
      height: 0.5px;
      background: #ededf0;
    }
    .spaceBtn {
      padding: 4px;
      margin-top: 10px;
      .btnDesativar {
        background: rgba(33, 51, 210, 0.1);
        box-shadow: 0px 4px 10px rgba(3, 148, 105, 0.03);
        border-radius: 5px;
        border: none;
        font-family: Montserrat;
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        color: #2133d2;
        height: 45px;
        width: 100%;
      }
    }
    .spaceNav {
      display: flex;
      justify-content: space-between;
      cursor: pointer;
      transform: translateY(0px);
      transition: transform 0.44s ease, box-shadow 0.44s ease;
      .text {
        font-family: Montserrat;
        font-style: normal;
        font-size: 15px;
        color: #81858e;
      }
    }
    .spaceNav:hover {
      transform: translateY(2px);
      transition: transform 0.44s ease, box-shadow 0.44s ease;
    }
  }
  .editModuleClass {
    position: fixed;
    background: rgba(0, 0, 0, 0.24);
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 9999999999999999999999999;
    .contentAdd {
      z-index: 99999999999999999999999999;
      position: absolute;
      padding: 30px;
      right: 0;
      top: 25vh;
      width: 303px;
      height: 295px;
      background: #ffffff;
      border: solid 1px var(--bordercolor);;
      box-sizing: border-box;
      border-radius: 3px;
      .close {
        cursor: pointer;
      }
      .space {
        margin-top: 40px;
        margin-bottom: 40px;
        input {
          border: 1px solid var(--bordercolor);
          box-sizing: border-box;
          border-radius: 5px;
          height: 40px;
          font-family: Montserrat;
          font-style: normal;
          font-weight: 600;
          font-size: 14px;
          color: #ededf0;
          overflow: hidden !important;
          resize: none !important;
          background: white;
        }
        input:hover,
        input:focus {
          border: 1px solid var(--maincolor);
          box-shadow: 0px 4px 10px rgba(3, 148, 105, 0.03);
          font-family: Montserrat;
          font-style: normal;
          font-weight: 600;
          font-size: 14px;
          color: #000000;
        }
        label {
          font-family: Montserrat;
          font-style: normal;
          font-weight: 600;
          font-size: 12px;
          color: #333333;
        }
        .btn-salvar {
          background: var(--maincolor);
          border-radius: 5px;
          border: none;
          width: 146px;
          font-family: Montserrat;
          color: #ffffff;
          font-style: normal;
          font-weight: 600;
          font-size: 14px;
          height: 40px;
        }
      }
      .title {
        font-family: Montserrat;
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        color: var(--maincolor);
      }
    }
  }

  .pt-5.spaceTop.col-md-12.col-12 {
    margin-top: 3em;
  }
  .editModuleClass {
    position: fixed;
    background: rgba(0, 0, 0, 0.24);
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 9999999999999999999999999;
    .contentAdd {
      z-index: 99999999999999999999999999;
      position: absolute;
      padding: 30px;
      right: 0;
      top: 25vh;
      width: 303px;
      height: 295px;
      background: #ffffff;
      border: solid 1px var(--bordercolor);;
      box-sizing: border-box;
      border-radius: 3px;
      .close {
        cursor: pointer;
      }
      .space {
        margin-top: 40px;
        margin-bottom: 40px;
        input {
          border: 1px solid var(--bordercolor);
          box-sizing: border-box;
          border-radius: 5px;
          height: 40px;
          font-family: Montserrat;
          font-style: normal;
          font-weight: 600;
          font-size: 14px;
          color: #ededf0;
          overflow: hidden !important;
          resize: none !important;
          background: white;
        }
        input:hover,
        input:focus {
          border: 1px solid var(--maincolor);
          box-shadow: 0px 4px 10px rgba(3, 148, 105, 0.03);
          font-family: Montserrat;
          font-style: normal;
          font-weight: 600;
          font-size: 14px;
          color: #000000;
        }

        .btn-salvar {
          background: var(--maincolor);
          border-radius: 5px;
          border: none;
          width: 146px;
          font-family: Montserrat;
          color: #ffffff;
          font-style: normal;
          font-weight: 600;
          font-size: 14px;
          height: 40px;
        }
      }
      .title {
        font-family: Montserrat;
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        color: var(--maincolor);
      }
    }
  }
  .hide {
    display: none !important;
  }
  .spaceAddCertify {
    padding-top: 53px;
    margin-left: 83px !important;
    .viewAulas {
      .flexAula {
        display: flex;
        justify-content: space-between;
        .flex {
          display: flex;
          .action {
            position: relative;
            top: 8px;
          }
          .play {
            position: relative;
            top: 6px;
          }
        }
      }
      .textAula {
        font-family: Montserrat;
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        color: #c4c4c4;
        margin-left: 20px;
      }
      .timeAula {
        font-family: Montserrat;
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        color: #c4c4c4;
      }
      .actionAula {
        display: flex;
        justify-content: space-between;
        svg {
          position: relative;
          left: 24px;
          z-index: 2;
        }
        button.btn.dropdown-toggle.btn-secondary,
        button.btn.dropdown-toggle.btn-secondary:hover,
        button.btn.dropdown-toggle.btn-secondary:focus,
        button.btn.dropdown-toggle.btn-secondary:active,
        button.btn.dropdown-toggle.btn-secondary:focus-within,
        button.btn.dropdown-toggle.btn-secondary:focus-visible {
          background: rgba(255, 255, 255, 0) !important;
          border: rgba(0, 0, 0, 0) !important;
          box-shadow: none !important;
          z-index: 9;
          color: #303e3e00 !important;
        }
        a.dropdown-item {
          font-family: Montserrat !important;
          font-style: normal !important;
          font-weight: 600 !important;
          font-size: 14px !important;
          color: #333 !important;
        }
        .dropdown-item:hover,
        .dropdown-item:focus {
          color: #333 !important;
          text-decoration: none !important;
          background-color: #fff !important;
        }
      }
    }
    .blur1 {
      position: fixed;
      left: 1px;
      bottom: -60px;
    }
    .blur2 {
      position: fixed;
      right: 1px;
      top: 80px;
      transform: rotate(180deg);
    }
    .spaceInputsCreate {
      display: flex;
      justify-content: flex-end;
      position: relative;
      left: 5em;
      top: -2em;
      .btn-criar {
        background: var(--maincolor);
        border: 1px solid var(--maincolor);
        box-sizing: border-box;
        box-shadow: 0px 4px 10px rgba(3, 148, 105, 0.03);
        border-radius: 5px;
        font-family: Montserrat;
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        color: #ffffff;
        width: 100%;
        height: 55px;
        width: 250px;
      }
    }
    .containerWizzardInputs {
      margin-left: auto;
      margin-right: auto;
      width: 95%;
      margin-top: 50px;
      .paddingNewModule {
        padding-left: 80px;
        padding-right: 80px;
        padding-top: 10px;
      }
      .btn-newModule {
        background: rgba(129, 133, 142, 0.03);
        border: 2px dashed #81858e;
        box-sizing: border-box;
        border-radius: 5px;
        height: 55px;
        cursor: pointer;
        .text {
          font-family: Montserrat;
          font-style: normal;
          font-weight: 600;
          font-size: 14px;
          color: #81858e;
          display: flex;
          justify-content: center;
          margin-top: 17px;
        }
      }
      .removemb {
        margin-bottom: 0px !important;
      }
      .actionModule {
        display: flex;
        justify-content: space-between;
        .titleModule {
          font-family: Montserrat;
          font-style: normal;
          font-weight: 600;
          font-size: 16px;
          color: var(--maincolor);
        }
        svg {
          position: relative;
          left: 24px;
          z-index: 2;
        }
        button.btn.dropdown-toggle.btn-secondary,
        button.btn.dropdown-toggle.btn-secondary:hover,
        button.btn.dropdown-toggle.btn-secondary:focus,
        button.btn.dropdown-toggle.btn-secondary:active,
        button.btn.dropdown-toggle.btn-secondary:focus-within,
        button.btn.dropdown-toggle.btn-secondary:focus-visible {
          background: rgba(255, 255, 255, 0) !important;
          border: rgba(0, 0, 0, 0) !important;
          box-shadow: none !important;
          z-index: 9;
          color: #303e3e00 !important;
        }
        a.dropdown-item {
          font-family: Montserrat !important;
          font-style: normal !important;
          font-weight: 600 !important;
          font-size: 14px !important;
          color: #333 !important;
        }
        .dropdown-item:hover,
        .dropdown-item:focus {
          color: #333 !important;
          text-decoration: none !important;
          background-color: #fff !important;
        }
      }
      .lineDiv {
        background: #ededf0;
        transform: matrix(1, 0, 0, -1, 0, 0);
        height: 0.5px;
        margin-top: 30px;
        margin-bottom: 30px;
      }
      .spaceModuleCard {
        width: 100%;
        background: #ffffff;
        border: 0.5px solid #e5e5e5;
        box-sizing: border-box;
        border-radius: 5px;
        padding: 32px;
        margin-bottom: 20px;
      }
      .spaceInputs {
        margin-bottom: 30px;
        .textInfo {
          font-family: Montserrat;
          font-style: normal;
          font-weight: normal;
          font-size: 12px;
          line-height: 15px;
          color: #81858e;
          margin-top: 5px;
        }
        .btn-criar {
          background: var(--maincolor);
          border: 1px solid var(--maincolor);
          box-sizing: border-box;
          box-shadow: 0px 4px 10px rgba(3, 148, 105, 0.03);
          border-radius: 5px;
          font-family: Montserrat;
          font-style: normal;
          font-weight: 600;
          font-size: 16px;
          color: #ffffff;
          width: 100%;
          height: 55px;
        }
        .btn-openModal {
          background: var(--maincolortrans);
          border: 2px dashed var(--maincolor);
          box-sizing: border-box;
          border-radius: 5px;
          height: 55px;
          cursor: pointer;
          .text {
            font-family: Montserrat;
            font-style: normal;
            font-weight: 600;
            font-size: 14px;
            color: var(--maincolor);
            display: flex;
            justify-content: center;
            margin-top: 17px;
          }
        }
        .gerenciarCat {
          font-family: Montserrat;
          font-style: normal;
          font-weight: 600;
          font-size: 12px;
          letter-spacing: 0.2px;
          color: var(--maincolor);
          position: absolute;
          right: 25em;
          cursor: pointer;
        }
        select {
          border: 1px solid var(--bordercolor);
          box-sizing: border-box;
          border-radius: 5px;
          height: 55px;
          font-family: Montserrat;
          font-style: normal;
          font-weight: 600;
          font-size: 14px;
          color: #6d767e;
          overflow: hidden !important;
          resize: none !important;
        }
        input,
        textarea {
          border: 1px solid var(--bordercolor);
          box-sizing: border-box;
          border-radius: 5px;
          height: 55px;
          font-family: Montserrat;
          font-style: normal;
          font-weight: 600;
          font-size: 14px;
          color: #000000;
          overflow: hidden !important;
          resize: none !important;
        }
        input:hover,
        select:hover,
        textarea:hover,
        input:focus,
        select:focus,
        textarea:focus {
          border: 1px solid var(--maincolor);
          box-shadow: 0px 4px 10px rgba(3, 148, 105, 0.03);
          font-family: Montserrat;
          font-style: normal;
          font-weight: 600;
          font-size: 14px;
          color: #000000;
        }
        label {
          font-family: Montserrat;
          font-style: normal;
          font-weight: 600;
          font-size: 14px;
          color: var(--fontcolor2);
        }
      }
    }
    .containerWizzard {
      text-align: center;
      .title {
        font-family: Montserrat;
        font-style: normal;
        font-weight: 800;
        font-size: 32px;
        align-items: center;
        color: var(--fontcolor);
      }
    }
  }
  .containerx {
    width: 98%;
  }
}
</style>